import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import ModalComponent from 'components/common/ModalComponent'
import BlockMapComponent from 'components/common/BlockMapComponent'

const BlockMapModal = ({
  isOpen,
  onClose,
  block,
  onUpdateBlockConfig,
  toggleIsTunnelRowModalOpen,
  tunnelRefreshRef
}) => {
  const { t } = useTranslation()
  if (!block) return null

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      title={t('mgmt.blockMap.title', { name: block.name || block.farmingBlockId })}
      maxWidth='screen'
      className='block-map-modal'
      contentClassName='block-map-modal-content'
      hideDefaultFooter
    >
      <BlockMapComponent
        toggleIsTunnelRowModalOpen={toggleIsTunnelRowModalOpen}
        tunnelRefreshRef={tunnelRefreshRef}
        {...block}
        onBlockConfigChange={(blockConfig) => {
          if (typeof onUpdateBlockConfig === 'function') {
            onUpdateBlockConfig(block, blockConfig)
          }
        }}
      />
    </ModalComponent>
  )
}

BlockMapModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  block: PropTypes.object,
  onUpdateBlockConfig: PropTypes.func,
  toggleIsTunnelRowModalOpen: PropTypes.func.isRequired,
  tunnelRefreshRef: PropTypes.shape({
    current: PropTypes.any
  })
}

export default BlockMapModal
